import angular from 'angular';
import employeeCardComponent from './employee-card.component';

let employeeCardModule = angular.module('employeeCard', [])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('employeeCard', employeeCardComponent);

export default employeeCardModule;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/components/employee-card/employee-card.js